import { DatePipe } from "@angular/common";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import {
    FormBuilder,
    FormControl,
    FormGroup,
    Validators,
} from "@angular/forms";
import { LocalStorageService, SessionStorageService } from "ngx-webstorage";
import { MessageService } from "primeng/api";
import "rxjs/Rx";
import { environment } from "src/environments/environment";
import { MyserviceService } from "../myservice.service";
@Component({
    selector: "app-archive-purge",
    templateUrl: "./archive-purge.component.html",
    styleUrls: ["./archive-purge.component.css"],
    providers: [MessageService],
})
export class ArchivePurgeComponent implements OnInit {
    firstRecordNo = 0;
    rowsNo = 10;
    loader:boolean;
    document: any = {};
    noRecords: boolean = false;
    searchData: any = [];
    transactionArray = [];
    userRole: string;
    addStatus = "";
    createdby: string;
    display1: boolean;
    responseMsg: boolean = false;
    archivePurgeInfoData: any = {};
    archivepurgeUpdateResultMessage = "";
    addarchivepurgeForm: FormGroup;
    public responseViewTime: boolean = false;
    tableHeaders: { field: string; header: string; width: string; }[];
    notValidArchive: boolean;
    notValidPurge: boolean;
    notValidPurgeEdit: boolean;
    notValidArchiveEdit: boolean;
    constructor(
        private myservice: MyserviceService,
        public session: SessionStorageService,
        public localstorage: LocalStorageService,
        private http: HttpClient,
        public datepipe: DatePipe,
        private fb: FormBuilder,
        private messageService: MessageService
    ) {}

    ngOnInit() {
        this.userRole = this.session.retrieve("userRole");
        this.setToDefault();

        this.addarchivepurgeForm = this.fb.group({
            transaction: new FormControl("-1", Validators.required),
            archiveDays: new FormControl("", Validators.required),
            purgeDays: new FormControl("", Validators.required),
        });
        this.tableHeaders = [
            { field: "transaction", header: "Transaction",width:"6%" },
            { field: "archiveDays", header: "Archive Days",width:"6%"  },
            { field: "purgeDays", header: "Purge Days",width:"6%"  },
            { field: "modifiedBy", header: "Modified By",width:"9%"  },
            { field: "modifiedDate", header: "Modified date",width:"10%"  },
        ];

        this.archivePurgeInfoData = [];
    }

    search(document) {
        document.purgeDays==""?this.notValidPurge=false:null;
        document.archiveDays==""?this.notValidArchive=false:null;
        this.loader=true;
        this.document = document;
        this.searchData = [];
        let headers = new HttpHeaders();
        headers = headers.append(
            "authorization",
            this.localstorage.retrieve("token")
        );
        this.http
            .get(
                environment.apiUrl +
                    "/archivePurge/search/" +
                    this.document.transaction+"?archiveDays="+this.document.archiveDays+"&purgeDays="+this.document.purgeDays,
                {
                    headers: headers,
                }
            )
            .subscribe((data) => {
                this.searchData = data;
                this.onPagination({first:0,rows:10})
                if (this.searchData.length == 0) {
                    this.noRecords = true;
                }
                this.loader=false;
            },
            (error)=>{
                this.loader=false;
            }
            );        
    }
    //For showing the page status
    onPagination(event) {
        this.firstRecordNo = event.first;
        this.rowsNo = event.first + event.rows >= this.searchData.length ? this.searchData.length : event.first + event.rows;
    }
    archivePurgeInfo(id) {
        this.notValidPurgeEdit=false;
        this.notValidArchiveEdit=false; 
        this.display1 = true;
        let headers = new HttpHeaders();
        headers = headers.append(
            "authorization",
            this.localstorage.retrieve("token")
        );
        this.http
            .get(environment.apiUrl + "/archivePurge/" + id, {
                headers: headers,
            })
            .subscribe((data) => {
                this.archivePurgeInfoData = data;
            });
    }

    update(archivePurgeInfoData) {
        this.archivePurgeInfoData = archivePurgeInfoData;
        let headers = new HttpHeaders();
        headers = headers.append(
            "authorization",
            this.localstorage.retrieve("token")
        );
        this.archivePurgeInfoData.modifiedBy =
            this.session.retrieve("UserDetails").userName;
        this.http
            .post(
                environment.apiUrl + "/archivePurge/update",
                this.archivePurgeInfoData,
                {
                    headers: headers,
                    responseType: "text",
                }
            )
            .subscribe((data) => {
                this.archivepurgeUpdateResultMessage = data;
                this.responseMsg = true;
                setTimeout(
                    function () {
                        this.responseMsg = false;
                    }.bind(this),
                    2000
                );
                this.search(this.document);
            });
    }

    add(document) {
        this.searchData = [];
        this.document = document;
        if (this.document.transaction == "-1") {
            alert("Please select transaction!");
            return false;
        }
        this.document.createdBy = this.session.retrieve("UserDetails").userName;
        let headers = new HttpHeaders();
        headers = headers.append(
            "authorization",
            this.localstorage.retrieve("token")
        );
        this.http
            .post(environment.apiUrl + "/archivePurge/add", this.document, {
                responseType: "text",
                headers: headers,
            })
            .subscribe((data) => {
                this.addStatus = data;
                if (this.addStatus == "") {
                    this.messageService.add({
                        severity: "error",
                        summary: "Error",
                        detail: "error",
                    });
                } else {
                    this.messageService.add({
                        severity: "success",
                        summary: "Success",
                        detail: this.addStatus,
                    });
                }
                this.responseViewTime = true;
                setTimeout(
                    function () {
                        this.responseViewTime = false;
                    }.bind(this),
                    2000
                );
                this.setToDefault();
                this.reset();
            });
    }

    setToDefault() {
        this.noRecords = false;
        this.transactionArray = this.myservice.getDocumentTypes(
            this.localstorage.retrieve("token"),
            "M",
            this.document.database
        );
        this.document.transaction = "-1";
        this.document.archiveDays = "";
        this.document.purgeDays = "";
        this.searchData = [];
        this.search(this.document);
    }

    reset() {
        this.addarchivepurgeForm.patchValue({
            archiveDays: "",
            purgeDays: "",
            transaction: "-1"
        }  
        )
        this.noRecords = false;
        this.searchData = [];
        this.document.transaction = "-1";
        this.document.archiveDays = "";
        this.document.purgeDays = "";
        this.search(this.document);
        this.notValidArchive=false;
        this.notValidPurge=false; 
    }
    validateArchive(){
         if (parseInt(this.addarchivepurgeForm.value.archiveDays)<=0||isNaN(this.addarchivepurgeForm.value.archiveDays)||parseInt(this.addarchivepurgeForm.value.archiveDays)%1!=0||this.addarchivepurgeForm.value.archiveDays.includes(".")) {
            this.notValidArchive=true;           
         }  
         else{
            this.notValidArchive=false; 
         }
    }
    validatePurge(){
        if (parseInt(this.addarchivepurgeForm.value.purgeDays)<=0||isNaN(this.addarchivepurgeForm.value.purgeDays)||parseInt(this.addarchivepurgeForm.value.purgeDays)%1!=0 || this.addarchivepurgeForm.value.purgeDays.includes(".")) {
            this.notValidPurge=true;           
         }  
         else{
            this.notValidPurge=false; 
         }
    }
    validateArchiveEdit(){
        if (parseInt(this.archivePurgeInfoData.archiveDays)<=0||isNaN(this.archivePurgeInfoData.archiveDays)||this.archivePurgeInfoData.archiveDays==""||parseInt(this.archivePurgeInfoData.archiveDays)%1!=0||this.archivePurgeInfoData.archiveDays.includes(".")) {
           this.notValidArchiveEdit=true;           
        }  
        else{
           this.notValidArchiveEdit=false; 
        }
   }
   validatePurgeEdit(){
       if (parseInt(this.archivePurgeInfoData.purgeDays)<=0||isNaN(this.archivePurgeInfoData.purgeDays)||this.archivePurgeInfoData.purgeDays==""||parseInt(this.archivePurgeInfoData.purgeDays)%1!=0||this.archivePurgeInfoData.purgeDays.includes(".")) {
           this.notValidPurgeEdit=true;           
        }  
        else{
           this.notValidPurgeEdit=false; 
        }
   }
}
